import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth.jsx';
import { ProtectedRoute } from './components/ProtectedRoute.jsx';
import { RateGate } from './components/RateGate.jsx';
import { AppShell } from './components/layout/AppShell.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import CustomersPage from './pages/customers/CustomersPage.jsx';
import ItemsPage from './pages/items/ItemsPage.jsx';
import SettingsPage from './pages/settings/SettingsPage.jsx';
import StockRegisterPage from './pages/reports/StockRegisterPage.jsx';
import ExportsPage from './pages/reports/ExportsPage.jsx';
import DailySalesPage from './pages/reports/DailySalesPage.jsx';
import GstSalesRegisterPage from './pages/reports/GstSalesRegisterPage.jsx';
import PendingIssuesPage from './pages/reports/PendingIssuesPage.jsx';
import RepairStatusPage from './pages/reports/RepairStatusPage.jsx';
import ChitDuesPage from './pages/reports/ChitDuesPage.jsx';
import OutstandingBalancesPage from './pages/reports/OutstandingBalancesPage.jsx';
import AuditLogPage from './pages/reports/AuditLogPage.jsx';
import InvoicesListPage from './pages/invoices/InvoicesListPage.jsx';
import InvoiceForm from './pages/invoices/InvoiceForm.jsx';
import InvoiceViewPage from './pages/invoices/InvoiceViewPage.jsx';
import GoldPurchasesListPage from './pages/goldPurchase/GoldPurchasesListPage.jsx';
import GoldPurchaseForm from './pages/goldPurchase/GoldPurchaseForm.jsx';
import GoldPurchaseViewPage from './pages/goldPurchase/GoldPurchaseViewPage.jsx';
import RepairsListPage from './pages/repairs/RepairsListPage.jsx';
import RepairForm from './pages/repairs/RepairForm.jsx';
import RepairViewPage from './pages/repairs/RepairViewPage.jsx';
import IssuesListPage from './pages/issueReceipt/IssuesListPage.jsx';
import IssueForm from './pages/issueReceipt/IssueForm.jsx';
import IssueViewPage from './pages/issueReceipt/IssueViewPage.jsx';
import ReceiptsListPage from './pages/issueReceipt/ReceiptsListPage.jsx';
import ReceiptForm from './pages/issueReceipt/ReceiptForm.jsx';
import ReceiptViewPage from './pages/issueReceipt/ReceiptViewPage.jsx';
import AccountsListPage from './pages/chit/AccountsListPage.jsx';
import SchemesListPage from './pages/chit/SchemesListPage.jsx';
import AccountForm from './pages/chit/AccountForm.jsx';
import AccountViewPage from './pages/chit/AccountViewPage.jsx';
import TemplatesListPage from './pages/settings/templates/TemplatesListPage.jsx';
import TemplateMapperPage from './pages/settings/templates/TemplateMapperPage.jsx';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route
            element={
              <RateGate>
                <AppShell />
              </RateGate>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="items" element={<ItemsPage />} />
            <Route path="invoices" element={<InvoicesListPage />} />
            <Route path="invoices/new" element={<InvoiceForm />} />
            <Route path="invoices/:id" element={<InvoiceViewPage />} />
            <Route path="gold-purchases" element={<GoldPurchasesListPage />} />
            <Route path="gold-purchases/new" element={<GoldPurchaseForm />} />
            <Route path="gold-purchases/:id" element={<GoldPurchaseViewPage />} />
            <Route path="repairs" element={<RepairsListPage />} />
            <Route path="repairs/new" element={<RepairForm />} />
            <Route path="repairs/:id" element={<RepairViewPage />} />
            <Route path="issue-receipt" element={<IssuesListPage />} />
            <Route path="issue-receipt/new" element={<IssueForm />} />
            <Route path="issue-receipt/receipts" element={<ReceiptsListPage />} />
            <Route path="issue-receipt/receipts/:id" element={<ReceiptViewPage />} />
            <Route path="issue-receipt/:id/receive" element={<ReceiptForm />} />
            <Route path="issue-receipt/:id" element={<IssueViewPage />} />
            <Route path="chit" element={<AccountsListPage />} />
            <Route path="chit/new" element={<AccountForm />} />
            <Route path="chit/schemes" element={<SchemesListPage />} />
            <Route path="chit/:id" element={<AccountViewPage />} />
            <Route path="reports/stock-register" element={<StockRegisterPage />} />
            <Route path="reports/exports" element={<ExportsPage />} />
            <Route path="reports/daily-sales" element={<DailySalesPage />} />
            <Route path="reports/gst-sales-register" element={<GstSalesRegisterPage />} />
            <Route path="reports/pending-issues" element={<PendingIssuesPage />} />
            <Route path="reports/repair-status" element={<RepairStatusPage />} />
            <Route path="reports/chit-dues" element={<ChitDuesPage />} />
            <Route path="reports/outstanding-balances" element={<OutstandingBalancesPage />} />
            <Route path="reports/audit-log" element={<AuditLogPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="settings/templates" element={<TemplatesListPage />} />
            <Route path="settings/templates/:id" element={<TemplateMapperPage />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}
